.delete-confirmation {
  margin-bottom: 1em;
}
